<template>
  <div class="geobooster-widgets-edit-form">
    <div class="geobooster-widgets-edit-form__line align-items-end gap-2 flex-row">
      <CustomSelect
        v-model="getBusinessField.value"
        :key="getBusinessField.name"
        :values="getBusinessField.values"
        :error="getBusinessField.error"
        :error-text="getBusinessField.errorText"
        :label="getBusinessField.label"
        :name="getBusinessField.name"
        :placeholder="'Select business'"
        :allow-empty="true" />
      <button
        class="geobooster-widgets-edit-form__button geobooster-widgets-edit-form__button--inline btn btn--rem"
        :class="{ disabled: disableAddButton }"
        :disabled="disableAddButton"
        @click="addBusiness">
        Add
      </button>
    </div>
    <div
      v-if="fields.selectedBusinesses.length !== 0"
      class="geobooster-widgets-edit-form__line flex-column gap-2">
      <div
        v-for="(selectedBusiness, index) in fields.selectedBusinesses"
        :key="selectedBusiness"
        class="geobooster-widgets-edit-form__tag">
        <span>{{ fields.businesses.values.find(business => business.value === selectedBusiness).text }}</span>
        <a
          href="#"
          class="geobooster-widgets-edit-form__cancel"
          @click.prevent="removeBusiness(index)">
          <i class="far fa-times" />
        </a>
      </div>
    </div>
    <div v-else class="geobooster-widgets-edit-form__line">
      <p>Please add at least one business to see moments</p>
    </div>
  </div>
</template>

<script>
import CustomSelect from '../../../components/custom_select'

export default {
  components: {
    CustomSelect
  },
  props: {
    fields: {
      type: Object,
      required: true
    }
  },
  methods: {
    addBusiness() {
      const businessToAdd = this.fields.businesses.value.trim()

      if (!this.fields.selectedBusinesses.includes(businessToAdd)) {
        const newSelectedBusinesses = [businessToAdd, ...this.fields.selectedBusinesses]
        this.$emit('updateBusinesses', newSelectedBusinesses)
      }
    },
    removeBusiness(index) {
      const newSelectedBusinesses = [...this.fields.selectedBusinesses]
      newSelectedBusinesses.splice(index, 1)
      this.$emit('updateBusinesses', newSelectedBusinesses)
    }
  },
  computed: {
    noBusinessSelected() {
      return !this.getBusinessField.value
    },
    selectedBusinessAlreadyAdded() {
      return this.fields.selectedBusinesses.includes(this.fields.businesses.value)
    },
    disableAddButton() {
      return this.selectedBusinessAlreadyAdded || this.noBusinessSelected
    },
    getBusinessField() {
      return this.fields.businesses
    }
  }
}
</script>
